import { Route, Routes } from "react-router-dom";
import { MenuPage } from "../../../pages/MenuPage/MenuPage";
import { SingleDishPage } from "../../../pages/SingleDishPage/SingleDishPage";
import Analytics from "../../../analytics/Analytics";
import {useEffect, useRef} from "react";
import {DISH_ROUTE, MENU_ROUTE} from "../../constants/routes";

export const AppRoutes = () => {
    const startTimeRef = useRef<number>(Date.now());
    const currentMenuIdRef = useRef<string | null>(null);


    useEffect(() => {
        const handleBeforeUnload = () => {
            if (currentMenuIdRef.current) {
                const duration = Date.now() - startTimeRef.current;
                Analytics.logMenuVisit(currentMenuIdRef?.current?.toString() ?? '', duration);

            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            if (currentMenuIdRef.current) {
                const duration = Date.now() - startTimeRef.current;
                Analytics.logMenuVisit(currentMenuIdRef?.current?.toString() ?? '', duration);
            }
        };
    }, []);

    const updateMenuId = (menuId: string | null) => {
        currentMenuIdRef.current = menuId;
        if (!startTimeRef.current) {
            startTimeRef.current = Date.now();
        }
    };

  return (
      <Routes>
          <Route path={MENU_ROUTE} element={<MenuPage updateMenuId={updateMenuId} />}/>
          <Route path={DISH_ROUTE} element={<SingleDishPage />} />
      </Routes>
  )
};
